import { useEffect, useRef, type MutableRefObject } from 'react';

/**
 * Returns a ref which can be assigned to any HTML element. Focuses
 * to the element on page load.
 *
 * Usage:
 * const ref = useAutofocus<HTMLDivElement>()
 * return <div ref={ref} tabIndex={-1} />
 */

export const useAutofocus = <
  T extends HTMLElement,
>(): MutableRefObject<T | null> => {
  const elemRef = useRef<T | null>(null);
  useEffect(() => {
    elemRef?.current?.focus();
  }, []);
  return elemRef;
};
